import DevSVG from "../../../../../svgs/DevSVG";
import GlobalSVG from "../../../../../svgs/GlobalSVG";
import PushingSVG from "../../../../../svgs/PushingSVG";
import Pin from "../../../../systemDesign/Sep/Pin";

const FirstSection = () => {
  return (
    <div className="w-full flex flex-col justify-center items-center py-[60px] border-b border-stroke1 text-text3 text-[13px] sm:text-[22px] md:text-[31px] [&>*>*]:inline-block">
      <h2>
        Develop with your favorite tools{" "}
        <DevSVG className="!scale-75 min-sm:!scale-100" />{" "}
      </h2>
      <h2>
        Launch globally, instantly{" "}
        <GlobalSVG className="!scale-75 min-sm:!scale-100" /> Keep pushing{" "}
        <PushingSVG className="!scale-75 min-sm:!scale-100" />{" "}
      </h2>
      <Pin className="-left-[10.5px] -top-[10.5px] md:hidden z-[11]" />
      <Pin className="-right-[10.5px] -top-[10.5px] md:scale-150 z-[11]" />
    </div>
  );
};

export default FirstSection;
